import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useEffect, useState } from "react";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";

interface DialogBoxComponentProps {
  openDialogBox: boolean;
  dialogTitle?: string;
  dialogBody?: string;
  isBtnsDisabled?: boolean;
  handleFunction?: () => void;
  handleCancel?: () => void;
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DuplicateDialogBox: React.FC<DialogBoxComponentProps> = (props) => {
  const [open, setOpen] = useState(false);
  const [dialogTitle, setDialogTitle] = useState<string>("");
  const [dialogBody, setDialogbody] = useState<string>("");

  useEffect(() => {
    setOpen(props.openDialogBox);
    setDialogTitle(props.dialogTitle || "");
    setDialogbody(props.dialogBody || "");
    // console.log("props.openDialogBox", props.openDialogBox);
  }, [props.openDialogBox]);

  const handleClose = () => {
    if (props.handleCancel) {
      props.handleCancel();
    }
  };

  const handleOk = () => {
    if (props.handleFunction) {
      props.handleFunction();
    }
  };

  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      TransitionComponent={Transition}
      keepMounted
    >
      <DialogTitle id="alert-dialog-title">{dialogTitle}</DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          dangerouslySetInnerHTML={{ __html: dialogBody }}
        ></DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button disabled={props.isBtnsDisabled} onClick={handleClose}>
          Cancel
        </Button>
        <Button disabled={props.isBtnsDisabled} onClick={handleOk} autoFocus>
          Duplicate
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DuplicateDialogBox;
